import React from 'react';
import { Container, Panel } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import { PageTitle } from 'components/v3/PageTitle/PageTitle';

export function TireWheelModule() {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle
        eyebrow={t('Lorem ipsum')}
        title={t('Tire & Wheel Preferences')}
        subtitle={t('Lorem ipsum dolor sit amet, consectetur adipiscing elit.')}
      />
      <Container></Container>
    </>
  );
}
